/**
 * PQR Details Services - API service layer for PQR (Procedure Qualification Record) detail operations
 * Handles CRUD operations for PQR detail records, process data, and related operations
 */
import axios from "axios";

// Dynamic API URL configuration based on environment
let PQR_API_URL;
if (process.env.REACT_APP_NODE_ENV === "local") {
  PQR_API_URL = process.env.REACT_APP_PQR_API_URL;
} else {
  PQR_API_URL = process.env.REACT_APP_API_URL + "pqr";
}


/**
 * Get PQR details by ID - ACTIVELY USED
 * Used in components:
 *   - Pdf_DownloadPQR.jsx - Get PQR data for PDF generation
 *   - PQRGrooveTransaction.jsx - Load PQR detail data for transactions
 * Purpose: Retrieve specific PQR detail record by ID
 * @param {Object} reqParam - Request parameters with PQR ID
 * @returns {Object} PQR detail record
 */
export const getdetailsById = async (reqParam) => {
  let url = `${PQR_API_URL}/PqrDetailsMast/getdetailsByIdPQR`;
  const response = await axios
    .post(url, reqParam)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  console.log("getdetailsById_url_detail", response.data);
  return response.data;
};



/**
 * Add new PQR detail record - ACTIVELY USED
 * Used in components:
 *   - PQRTubesheetPage1.jsx - Add new PQR detail for tubesheet operations
 *   - PQR_Page1.jsx - Add new PQR detail records
 * Purpose: Create new PQR detail record
 * @param {Object} PQR_Details_Master - PQR detail data to create
 * @returns {Object} Creation response
 */
export const AddNewDetail = async (PQR_Details_Master) => {
  let url = `${PQR_API_URL}/PqrDetailsMast`;
  console.log("AddNewDetail_url", url, PQR_Details_Master);
  const response = await axios
    .post(url, PQR_Details_Master)
    .finally(() => {
      console.log("second page service");
    })
    .then(function (resp) {
      console.log("second page service", resp);
      return resp;
    })
    .catch(function (error) {
      console.log("second page service", error);
      return { message: "Unable to find request", status: false };
    });
  console.log("second page in servuce", response);
  return response;
};



/**
 * Delete PQR process/detail record - ACTIVELY USED
 * Used in components:
 *   - PQRProcess.js - Delete PQR process records
 *   - PQR_Page1.jsx - Delete PQR detail records
 * Purpose: Delete specific PQR detail/process record
 * @param {string} pkid - Primary key ID
 * @param {string} skid - Secondary key ID
 * @returns {Object} Deletion response
 */
export async function DeletePQRProcess(pkid, skid) {
  console.log("DeletePQRProcess pkid:", pkid);

  let url = `${PQR_API_URL}/PqrDetailsMast/delete`;
  let reqbody = { PK: pkid, SK: skid };
  console.log("DeletePQRProcess reqbody:", reqbody);
  const resp = await axios
    .post(url, reqbody)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return error.message;
    });

  return resp;
}

/**
 * Get PQR details for editing - ACTIVELY USED
 * Used in components:
 *   - PQRTubeSheetTransaction.jsx - Load PQR details for editing
 * Purpose: Retrieve PQR detail data formatted for editing operations
 * @param {Object} reqData - Request data for PQR detail retrieval
 * @returns {Object} PQR detail data formatted for editing
 */
export const getPQRDetailsEdit = async (reqData) => {
  let url = `${PQR_API_URL}/PqrDetailsMast/getPQRDetailsEdit`;
  console.log("getPQRDetailsEdit_url", url);
  console.log("reqData", reqData);
  const response = await axios
    .post(url, reqData)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};
